import type { PolymorphicSegment } from '@repo/poly-hooks/segment';

export interface CallIdentify {
  type: 'identify';
  userId?: string;
  traits: Record<string, unknown>;
}

export interface CallTrack {
  type: 'track';
  event: string;
  params?: Record<string, unknown>;
}

export interface CallReset {
  type: 'reset';
}

export interface CallGroup {
  type: 'group';
  params?: Record<string, unknown>;
}

export type Call = CallIdentify | CallTrack | CallReset | CallGroup;

export class SegmentMock implements PolymorphicSegment {
  identify(arg1: string | Record<string, unknown>, arg2?: Record<string, unknown>): void {
    if (arg2 === undefined) {
      window.__segment?.push({
        type: 'identify',
        traits: arg1 as Record<string, unknown>,
      });
    } else {
      window.__segment?.push({ type: 'identify', userId: arg1 as string, traits: arg2 });
    }
  }

  track(event: string, params?: Record<string, unknown>): void {
    window.__segment?.push({ type: 'track', event, params });
  }

  page(_params: Record<string, unknown>): void {
    // noop in tests
  }

  reset() {
    window.__segment?.push({ type: 'reset' });
  }

  group(params?: Record<string, unknown>): void {
    window.__segment?.push({ type: 'group', params });
  }
}

declare global {
  interface Window {
    __segment?: Call[];
  }
}
